import moment, { Moment } from 'moment';
import React from 'react';
import GridFilter from '../../../../Base/Components/GridFilter/GridFilter';
import GridFilterItem from '../../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../../Base/Enums/GridFilterItemType.enum';
import { SelectValue } from '../../../../../Components/Base/Select/Select';
import { useAppContext } from '../../../../../Services/AppContext';
import { GRID_FILTER_KEYS } from '../../../../Base/Components/GridFilter/gridFilterKeys';

export interface SurveillanceCenterFilterValues {
	createdAt?: Moment | string;
	patientId?: string;
	workplaceIds?: string[];
	doctorNull: boolean;
	workplaceId: string;
}

interface Props {
	onFilter: (values: SurveillanceCenterFilterValues) => void;
}

const SurveillanceCenterFilter: React.FC<Props> = ({ onFilter }) => {
	const { workplaceId } = useAppContext();
	const onFilterData = (values: any) => {
		const filter: SurveillanceCenterFilterValues = {
			createdAt: values?.createdAt
				? moment(values.createdAt).format('YYYY-MM-DD')
				: undefined,
			patientId: values?.patient?.value || undefined,
			workplaceIds: values?.workplaceIds
				? values.workplaceIds.map((item: SelectValue) => item.value)
				: undefined,
			doctorNull: false,
			workplaceId,
		};
		onFilter(filter);
	};

	return (
		<GridFilter
			onChange={onFilterData}
			storageKey={GRID_FILTER_KEYS.SURVEILLANCE_CENTER_FILTER}>
			<GridFilterItem
				type={GridFilterItemType.WORKPLACES}
				width={320}
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.PATIENT_ID}
				width={320}
				customPlaceholder='base.startTypingSurname'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.CREATED_AT}
				width={190}
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default SurveillanceCenterFilter;
